import React from 'react';
import { RadioGroupYesNo } from './RadioGroupYesNo';
import { AppInputTextFormik } from 'primitives/input/appInputText';
import { FormError } from 'primitives/input/formError';
import {
  FormikPropsSlice,
  getFormikError,
  getFormikValue,
} from 'primitives/input/formikUtils';
import { ShIntlMessageDefinition, ShText } from '@shoootin/translations';
import { getFrontMessage } from '../../../appMessageDefinitions';
import { ShCol, ShRow } from '@shoootin/components-web';
import { ShService } from '@shoootin/config';

export const MaterialRowYesNo = <
  FieldName extends string,
  FieldName2 extends string
>({
  form,
  name,
  label,
  precisionName, // field name used to precise if true
  onCheck,
  service,
}: {
  form: FormikPropsSlice<FieldName>;
  name: FieldName;
  label: ShIntlMessageDefinition;
  precisionName?: FieldName2;
  onCheck?: () => void;
  service: ShService;
}) => {
  const error = getFormikError(form, name);
  const value = getFormikValue(form, name) as boolean;
  return (
    <ShRow className={'field-row wrap-s'}>
      <ShCol xs={60} sm={30} md={20} lg={20}>
        <label>
          <ShText message={label} />{' '}
        </label>
      </ShCol>
      <ShCol
        xs={60}
        sm={30}
        md={20}
        lg={15}
        className="photograph-gear__toggle"
      >
        <RadioGroupYesNo
          form={form}
          name={name}
          onCheck={onCheck}
          service={service}
        />
      </ShCol>
      <ShCol xs={60} md={20} lg={25}>
        {precisionName && value && (
          <AppInputTextFormik
            form={form}
            name={precisionName}
            placeholderMessage={getFrontMessage(
              'form_prospectPhotographerPhotoMaterial_ifYesLabel_PlaceHolder',
            )}
            modifier="large"
          />
        )}
        {!value && error && <FormError error={error} />}
      </ShCol>
    </ShRow>
  );
};
